import { ApiBase } from 'utils/api';


export default class NotificationApi  {
    private base: ApiBase;

    constructor(base: ApiBase) {
        this.base = base;
    }

    auth = (channel: any) => (socketId: any, callback: any) => {
        this.base.axios.post('/api/broadcasting/auth', {
            socket_id: socketId,
            channel_name: channel.name
        })
            .then((response: any) => {
                callback(false, response.data);
            })
            .catch((error: any) => {
                callback(true, error);
            });
    };

    get = (cursor?: string) => {
        return this.base.axios.get('/api/notifications?', cursor ? {params: {cursor}} : undefined);
    };
}
